import React from 'react';
import styles from '../../styles/match-event-placeholders.module.scss'
import classNames from "classnames";
import {MatchEventModulePlaceholderEvents} from "./match-event.module.placeholder.events";

export const MatchEventModulePlaceholderStages = ({stagesNum, eventsNum}) => {
  let stages: Array<Number> = [];

  for(let i=0; i<stagesNum; i++){
    stages.push(parseInt(eventsNum/stagesNum))
  }

  return (
    stages.map((rows, index) => <React.Fragment key={index}>
      <div className={classNames(styles.stage)}/>
      <MatchEventModulePlaceholderEvents eventsNum={rows}/>
    </React.Fragment>)
  )
};
